import { render, staticRenderFns } from "./PdfReadonlyPanel.vue?vue&type=template&id=74591896"
import script from "./PdfReadonlyPanel.vue?vue&type=script&lang=js"
export * from "./PdfReadonlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports